import { render, staticRenderFns } from "./StudentAnswer.vue?vue&type=template&id=4c5ff110&scoped=true"
import script from "./StudentAnswer.vue?vue&type=script&lang=js"
export * from "./StudentAnswer.vue?vue&type=script&lang=js"
import style0 from "./StudentAnswer.vue?vue&type=style&index=0&id=4c5ff110&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c5ff110",
  null
  
)

export default component.exports